import React from "react";
import { TIMER_STATUS } from "../../constants";
import {
    selectNotes, selectSetting, selectStrategy,
    selectTimeCount,
    selectTimeCountEnded,
    selectTimeCountStarted,
    selectTimerStatus, setNotes, setSetting,
    startTimer,
    stopTimer,
    selectPlannedLuckets,
    selectCurrentActiveLucketId,
    setActiveLuckets,
    setCurrentActiveLucket
} from "../../sessionWatchSlice";
import { selectCurrentMindMap, selectCurrentMindMapId, saveMindMap } from "../../../../../mind-2/slice/mindSlice2";
import { useDispatch, useSelector } from "react-redux";
import "./Timer.css"; // import stylesheet
import { SESSION_TRACKER_BACKGROUND_COLOR } from "../../../../../buckets/constants";

export const Timer = () => {
    const dispatch = useDispatch();
    const timeCount = useSelector(selectTimeCount);
    const timeSpentSeconds = Math.floor(timeCount / 1000);
    const timerStatus = useSelector(selectTimerStatus);
    const timeCountEnded = useSelector(selectTimeCountEnded);
    const timeCountStarted = useSelector(selectTimeCountStarted);
    const notes = useSelector(selectNotes);
    const strategy = useSelector(selectStrategy);
    const setting = useSelector(selectSetting);
    const plannedLuckets = useSelector(selectPlannedLuckets);
    const currentActiveLucketId = useSelector(selectCurrentActiveLucketId);
    const currentMindMap = useSelector(selectCurrentMindMap);
    const currentMindMapId = useSelector(selectCurrentMindMapId);

    const logSessionEvent = (type, timestamp) => {
        const today = new Date().toISOString().split("T")[0];
        const key = `sessionTimeline_${today}`;
        const existing = JSON.parse(localStorage.getItem(key)) || [];
        existing.push({ type, timestamp });
        localStorage.setItem(key, JSON.stringify(existing));
    };

    const handleStart = () => {
        dispatch(startTimer());
        logSessionEvent("start", new Date().getTime());

        // Initialize active luckets from planned luckets
        dispatch(setActiveLuckets([...plannedLuckets]));

        // If there's only one planned lucket, make it the current active one
        if (plannedLuckets.length === 1) {
            dispatch(setCurrentActiveLucket(plannedLuckets[0]));
        }

        // Reset mind map to fresh state with just root node
        dispatch(saveMindMap({
            id: 'default',
            nodes: [{ id: 'root', text: 'Root Idea', x: 400, y: 300, children: [] }]
        }));
    };

    const handleStopAndSave = () => {
        // Close any open lucket time segment
        if (currentActiveLucketId) {
            dispatch(setCurrentActiveLucket(null));
        }

        dispatch(stopTimer());
        logSessionEvent("stop", new Date().getTime());

        const today = new Date().toISOString().split("T")[0];
        const sessionTimelineStored = localStorage.getItem(`sessionTimeline_${today}`)
        const toObject = JSON.parse(sessionTimelineStored);
        const timeCountStarted1 = toObject[toObject.length - 1].timestamp;
        const timeCountEnded1 = toObject[toObject.length - 2].timestamp;
        const timeDifference = (timeCountStarted1 - timeCountEnded1)


        const sessionLengthSec = Math.floor(timeDifference / 1000);


        const fullNote = `${notes}-${sessionLengthSec}-${setting}`;

        // Check if mind map has been modified (more than just root node or root text changed)
        const hasModifiedMindMap = currentMindMap && currentMindMap.nodes && !(
            currentMindMap.nodes.length === 1 &&
            currentMindMap.nodes[0].id === 'root' &&
            currentMindMap.nodes[0].text === 'Root Idea' &&
            (!currentMindMap.nodes[0].children || currentMindMap.nodes[0].children.length === 0)
        );

        // Save note by date (including mind map data if it exists and was modified)
        const noteKey = `notes_${today}`;
        const existingNotes = JSON.parse(localStorage.getItem(noteKey)) || [];

        // Create note object with mind map data only if it was actually used
        const noteData = {
            note: fullNote,
            mindMap: hasModifiedMindMap ? {
                id: currentMindMapId,
                nodes: currentMindMap.nodes,
                lastModified: currentMindMap.lastModified
            } : null,
            timestamp: new Date().toISOString()
        };

        existingNotes.push(noteData);
        localStorage.setItem(noteKey, JSON.stringify(existingNotes));

        // Save strategy
        localStorage.setItem("strategies", JSON.stringify(strategy));

        // Clear note field only
        dispatch(setNotes(""));
    };

    return (
        <div className="timer-container" style={{ backgroundColor: SESSION_TRACKER_BACKGROUND_COLOR }}>


            {(timerStatus === TIMER_STATUS[0] && timeCountEnded) && (
                <div className="timer-stats">
                    <h4>📊 Previous Stats</h4>
                    <p><strong>Started:</strong> {new Date(timeCountStarted).toLocaleTimeString()}</p>
                    <p><strong>Ended:</strong> {new Date(timeCountEnded).toLocaleTimeString()}</p>
                    <p><strong>Duration:</strong> {(timeCountEnded - timeCountStarted) / 1000} seconds</p>
                </div>
            )}

            {timerStatus === TIMER_STATUS[0] ? (
                <div className="timer-input-block">
                    <label className="labelSettingInput" htmlFor="settingInput">Workplace</label>
                    <input
                        id="settingInput"
                        onChange={e => dispatch(setSetting(e.target.value))}
                        placeholder="Library, Office, Home etc.."
                    />
                    <button
                        className="btn start-btn"
                        key={setting.length === 0 ? "1starttimer" : "2starttimer"}
                        disabled={setting.length === 0}
                        onClick={handleStart}
                    >
                        Start
                    </button>
                </div>
            ) : (
                <button className="btn stop-btn" onClick={handleStopAndSave}>
                    Stop Timer
                </button>
            )}
        </div>
    );
};